import {
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAIL,
} from "../actionTypes";

export const getOrders = (navigate) => async (dispatch) => {
  try {
    dispatch({
      type: ORDER_DETAILS_REQUEST,
    });
    const res = await fetch("/api/orders/latest", {
      method: "GET",
      credentials: "include",
    });

    // If status is not a 200 - this assumes that it is a 401 un-authorized
    if (res.status !== 200) {
      navigate("/");
    } else {
      const data = await res.json();
      dispatch({
        type: ORDER_DETAILS_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
